module.exports = __webpack_public_path__ + "img/147.bc8b6a2c.jpg";